/**
 * Created by intellicar-rinas on 12/3/18.
 */

import _ from 'lodash';

/* ======================================================

 Available Graphs

 'gpsspeed',
 'odometer',
 'rpm',
 'speed',
 'enginetemp',
 'battery',
 'fuellevel',
 'numsat',
 'ac',
 'seatBelt',
 'headLight',
 'userScore',
 'nanoBattery',
 'rssi',
 'magnet',
 'ambientLight',

 'getBaseScreedTemperature',
 'getLeftScreedTemperature',
 'getActualEngineSpeed',
 'getEngineHours',
 'getPavingDistance',
 'getTravelDistanceHighGear',
 'getBatteryChargeIndication',
 'getLowGearMoving',
 'getScreenHeatingMode',
 'getWorkTimeHours',

 ==========================================================*/


export const graphFilterMap = {
    //can
    'caniq': {
        whiteList: ['speed', 'odometerGPS',  'distanceGPS','speedGPS', 'odometer', 'distance', 'battery', 'numsat', 'rpm', 'enginetemp', 'fuellevelPercentage', 'fuellevel',
            'ac', 'headLight', 'seatBelt']
    },
    'ermtrackersf_edata': {
        whiteList: ['speed', 'odometer', 'distance', 'odometerGPS',  'distanceGPS','speedGPS', 'battery', 'numsat', 'rpm', 'enginetemp', 'fuellevelPercentage', 'fuellevel',
            'ac', 'headLight', 'seatBelt', 'gearstate', 'gearstatedistribution','battery_voltage']
    },
    'erm_evcan': {
        whiteList: ['odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'fuellevelPercentage', 'fuellevel', 'soh', 'kwh',"battery_temp","battery_current","battery_voltage",'odometer','engine_speed','brake_pedal']
    },
    'erm_starlinkone': {
        whiteList: ['odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'fuellevel']
    },
    'sino': {
        whiteList: ['odometerGPS', 'speedGPS', 'distanceGPS', 'speed', 'battery', 'numsat', 'rpm', 'enginetemp']
    },

    //GPS
    'cr300': {
        whiteList: [ 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'fuellevel']
    },
    'rdgps': {
        whiteList: [ 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat']
    },
    'ermtrackersf': {
        whiteList: [ 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat']
    },
    'cello': {
        whiteList: [ 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat']
    },
    'ermtogo': {
        whiteList: [ 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat']
    },
    'concox_assettracker': {
        whiteList: ['devicebattery', 'speedGPS', 'numsat']
    },
    'concox_at4': {
        whiteList: ['devicebattery', 'speedGPS', 'numsat']
    },
    'concoxgt06n': {
        whiteList: [ 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat']
    },
    'nano': {
        whiteList: [ 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat',
            'ambientLight', 'nanoBattery', 'magnet', 'rssi']
    },
    'autocop': {
        whiteList: ['odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'tilt', 'gsensor']
    },
    'ashleygps': {
        whiteList: ['odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'tilt', 'gsensor']
    },
    'teltonika_fmb920': {
        whiteList: ['odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'tilt', 'gsensor', 'fuellevelPercentage', 'fuellevel',"battery_voltage"]
    },
    'teltonika_fmb208': {
        whiteList: ['odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'tilt', 'gsensor', 'fuellevelPercentage', 'fuellevel',"battery_voltage"]
    },
    'teltonika_tft100': {
        whiteList: ['odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'tilt', 'gsensor', 'fuellevelPercentage', 'fuellevel',"battery_voltage"]
    },
    'teltonika_fmb207': {
        whiteList: ['odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'tilt', 'gsensor']
    },
    'teltonika_fmb001': {
        whiteList: ['speed', 'odometerGPS',  'distanceGPS','speedGPS', 'odometer', 'distance', 'battery', 'numsat', 'rpm', 'enginetemp', 'fuellevelPercentage', 'fuellevel',
        'ac', 'headLight', 'seatBelt']
    },
    'teltonika_fmb640': {
        whiteList: ['speed', 'odometerGPS',  'distanceGPS','speedGPS', 'odometer', 'distance', 'battery', 'numsat', 'rpm', 'enginetemp', 'fuellevelPercentage', 'fuellevel',
        'ac', 'headLight', 'seatBelt']
    },
    'volty_transync_ais140_v1': {
        whiteList: ['devicebattery', 'speedGPS', 'numsat', 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery']
    },
    'itriangle_bharat101': {
        whiteList: ['devicebattery', 'speedGPS', 'numsat', 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery'],
    },
    'intelliblu': {
        whiteList: [],
    },
    'accord_navitrack257': {
        whiteList: ['devicebattery', 'speedGPS', 'numsat', 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery'],
    },
    'jio_jvt1440': {
        whiteList: ['devicebattery', 'speedGPS', 'numsat', 'odometerGPS', 'distanceGPS', 'speedGPS', 'battery']
    },
    'minitrack': {
        whiteList: ['odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat', 'tilt', 'gsensor', 'fuellevelPercentage', 'fuellevel']
    },
    'laf': {
        whiteList: ['speed', 'odometerGPS',  'distanceGPS','speedGPS', 'odometer', 'distance', 'battery', 'numsat', 'rpm', 'enginetemp', 'fuellevelPercentage', 'fuellevel',
             'ac','seatBelt','headLight']
    },
};


/*
*
*   Graphs Based on Vehicle Model 
*
*   [Vehicle Models should be in lower case]    
*
* */


export const graphFilterMapByVehicleModel = {
    'asphalt paver p5320': {
        whiteList: [
            // Paver specific Graphs
            'getBaseScreedTemperature',
            'getLeftScreedTemperature',
            'getActualEngineSpeed',
            'getEngineHours',
            'getPavingDistance',
            'getTravelDistanceHighGear',
            'getBatteryChargeIndication',
            'getLowGearMoving',
            'getScreenHeatingMode',
            'getWorkTimeHours',

            // CanIQ graphs [Available in Paver]
            'speed', 'odometer', 'battery', 'numsat', 'rpm', 'enginetemp', 'fuellevel',]
    },
    'tvs_poc': {
        whiteList: [
            // cr300
            'odometerGPS', 'distanceGPS', 'speedGPS', 'battery', 'numsat',
            // can
            'tvs_battery_amp', 'tvs_battery_volt', 'tvs_diff',
            'tvs_finn', 'tvs_frontodo', 'tvs_fuel', 'tvs_map',
            'tvs_oiltemp', 'tvs_rearodo', 'tvs_rpm', 'tvs_rspeed',
            'tvs_speed', 'tvs_throttle'
        ]
    },
    'tork': {
        whiteList: [
            // caniq
            'speed', 'odometerGPS',  'distanceGPS','speedGPS', 'odometer', 'distance', 'battery', 'numsat', 'rpm', 'enginetemp', 'fuellevelPercentage', 'fuellevel',
            'ac', 'headLight', 'seatBelt',
            // can
            'torkCurrentHistory', 'torkVoltageHistory','throttleInputVoltageHistory', 'torkMotorTempHistory', 'torkECUTempHistory', 'torkTorqueHistory',"battery_voltage","temperature_can"
        ]
    }
};



/*
*
*
*
*
* */


const checkGraphVisibility =(vehicle, graph, visibility)=>{
    // console.log("key",graph.key)

    if(!vehicle)
        return false;


    /*
    *   Fuel Graph check
    * */

    if(vehicle && vehicle.vehiclemeta && vehicle.vehiclemeta.fuellevelfrom && vehicle.vehiclemeta.fuellevelfrom.length && graph && graph.key === 'fuellevel') {
        visibility = true;
    }

    if(graph.key === 'fuellevel_combined' && _.get(vehicle, 'vehiclemeta.num_fuelsensors') === 2) {
        return true;
    }

    /*
    *
    *   Only For Paver
    *
    * */

    if(vehicle.vehiclemeta && vehicle.vehiclemeta.model) {
        let vehicleModel = vehicle.vehiclemeta.model.toLowerCase().trim();
        if(vehicleModel in graphFilterMapByVehicleModel) {
            return graphFilterMapByVehicleModel[vehicleModel].whiteList.indexOf(graph.key) !== -1;
        }

    }   

    /**
     * Boat
     */
    if(graph.key === 'distanceGPS_boat') {
        visibility = false;
        let vehicletype = _.get(vehicle, 'vehiclemeta.vehicletype', '');
        if(vehicletype.toLowerCase() === 'boat') {
            visibility = true;
        }
    }
    if(graph.key === 'distanceGPS') {
        let vehicletype = _.get(vehicle, 'vehiclemeta.vehicletype', '');
        if(vehicletype.toLowerCase() === 'boat') {
            visibility = false;
        }
    }

    return visibility;
};


const getVehicle =()=> {

    let vehicle = null;

    if(window.selectedVehicles && window.selectedVehicles[0] && window.selectedVehicles[0].data) {
        vehicle = window.selectedVehicles[0].data;
    }

    return vehicle;
};


const isGraphVisible = (graph)=> {

    let visibility;
    let devicetypes = [];
    let allowedGraphs = [];
    let vehicle = getVehicle();
    let disableGraphs = window.userInfo.SELF.disable_graphs ? window.userInfo.SELF.disable_graphs : null

    if(!vehicle)
        return false;

    // console.log("datas",vehicle,this.props)        
    let ipigpc = _.get(vehicle, 'vehiclemeta.graphpresetconfig', []).includes(graph.key);
    if(ipigpc) return true;

    if(vehicle && vehicle.devices) {
        for(let idx in vehicle.devices) {
            devicetypes.push(vehicle.devices[idx].devicetype);
        }
    }

    if(devicetypes.length === 0) {
        devicetypes.push('caniq')
    }

    for(let idx in devicetypes) {
        allowedGraphs = [...allowedGraphs, ...(graphFilterMap[devicetypes[idx]] ? graphFilterMap[devicetypes[idx]].whiteList : [])];
    }

    visibility = allowedGraphs.indexOf(graph.key) !== -1;

    if(vehicle.type === 'user') {
        return ['gpsspeed', 'speedGPS', 'phoneBatteryHistory', 'userSignal'].indexOf(graph.key) !== -1;
    }

    /**
     * user,group,customer specific graphs
    */
    function checkGroup(groups) {
    //    console.log(vehicle.groups)
        
        return vehicle.groups.map(f => groups.includes(f.name)).includes(true);
    }

    function checkParentGroup(id) {
        let groupids = id;
        // console.log("ids",groupids)
        const groups = vehicle.groups;
        const gPath = [];
        const gTree = [];

        for(let i in groups) {
            if(groups[i].path){
              gTree.push(groups[i].path)
              gPath.push(gTree[i].split('/').filter(f => f).map(f => parseInt(f, 10)));
            }
          }
          for(let idx in gPath){
              let group = gPath[idx]
              for(let ldx in group){
                  for(let rdx in groupids){
                     if( group[ldx] === groupids[rdx]) return true
                  }
              }
          }
    }
    // etrio
   // let isEtrioParent = checkParentGroup(EtrioId)
    let groups = vehicle.groups.map(f => f.name);
    let isEtrio = groups.includes('eTrio');
    let isEv = _.get(vehicle, 'vehicleModel.fueltype') === 'EV';
    let isBike = _.get(vehicle, 'vehicleModel.vehicletype') === 'Bike';
    let etrioGraphs = ['torkBatteryVoltageHistory', 'torkTempHistory', 'torkCellVoltageHistory', 'torkMotorSpeedHistory','throttleInputVoltageHistory'];
    let showEtrioGraph = isEtrio && isEv && etrioGraphs.includes(graph.key);
    let isGps = _.get(vehicle, 'vehiclemeta.installation_type') === 'GPS';
    if(graph.key === "non_can_soc" && isEv && isGps) return true
    if(showEtrioGraph) return true;
    // 2023 -greenfuel,1822 - amplus, etrio
    let addGraphs = window.userInfo.SELF.add_graphs ? window.userInfo.SELF.add_graphs : null
    if(addGraphs != null && addGraphs.length != 0 && addGraphs.includes(graph.key)){
        return true;
    }
    if(disableGraphs && disableGraphs.length && disableGraphs.includes(graph.key) ){
        return false
    }

    if(graph.key === "battery_temp" && checkParentGroup([1979,1822,2023])) return true;
    if(graph.key ==="bms_temperature" && isEv) return true;
    // temp sensor - Bosch
    if(graph.key === "temperature" && checkParentGroup([2518])) return true;
    // Magenta

    let magentaGraph2 = ['ac','seatBelt','gearstate','drive_mode','gearstatedistribution']    
    if(graph.key === "battery_current" && checkParentGroup([2484])) return true; 
    if(graph.key === "acceleration_pedal_position" && checkParentGroup([2484])) return true;
    if( checkParentGroup([2484]) && magentaGraph2.includes(graph.key))  return true;
    if(graph.key === "gearstatedistribution" && checkParentGroup([2484]))  return false;
    //OKplay and kinetic
    if(graph.key === 'controller_temperature' && checkGroup(['Kineticgreen'])) return true;
    if(graph.key === 'battery_current' && checkGroup(['OkPlay','Kineticgreen','Oye_Rickshaw','Log9','GPOWER'])) return true;
    if(graph.key === 'battery_voltage' && checkGroup(['Oye_Rickshaw','Log9'])) return true;
    if(graph.key === 'cell_temp' && checkGroup(['Oye_Rickshaw','Log9'])) return true;
    if(graph.key === 'charge_discharge_cycle' && checkGroup(['Oye_Rickshaw','Log9'])) return true;
    // tork
    const isTork = groups.includes('TORK_THP');
    const torkGraphs = ['torkVoltageHistory', 'torkCurrentHistory', 'torkMotorTempHistory', 'throttleInputVoltageHistory'];
    if(isTork && torkGraphs.includes(graph.key)) return true;
    if(groups.includes("TORK_KRATOS") && graph.key === "temperature_can") return true

    let isMagenta = groups.includes('Magenta')
    let magentaGraph = ['ac','seatBelt','gearstate']
    if(isMagenta && magentaGraph.includes(graph.key)) return true;

    //alvarez
    const isAlvarez = groups.includes('AlvarezMarshal');
    const alvarezGraphs = ['temperature'];
    if(isAlvarez && alvarezGraphs.includes(graph.key)) return true;
 

    let hiddenEtrioGraphs = ['rpm', 'enginetemp'];
    let hideEtrioGraph = isEtrio && isEv && hiddenEtrioGraphs.includes(graph.key);
    if(hideEtrioGraph) return false;
    // KPTL pulse graphs
    if(graph.key === 'pulsegraph' && checkGroup(['KPTL_Jhunjhunu', 'KPTL_Bhubaneshwar'])) return true;
    if(graph.key === 'temperature' && checkGroup(['KPTL_Jhunjhunu', 'KPTL_Bhubaneshwar'])) return true;
    if(graph.key === 'pressure' && checkGroup(['KPTL_Jhunjhunu', 'KPTL_Bhubaneshwar'])) return true;

    //FLO
    if(graph.key === 'ev_battery_voltage' && checkGroup(['FLO','EKKOGROUP'])) return true;
    // for Livguard test
    if(graph.key === 'battery_temp' && !checkGroup(['Livguard',"Livguarddemo"])) return false;
    if(graph.key === 'battery_current' && !checkGroup(['Livguard',"Livguarddemo"])) return false;
    if(graph.key === 'battery_voltage' && !isEv) return false;
    if(graph.key === 'charge_type' && isEv) return true;
    if((graph.key === 'ac' || graph.key === 'seatBelt') && isBike) return false;

    let dynamicGraph = graph.dynamicGraph && vehicle;
    let showGraph = checkGraphVisibility(vehicle, graph, visibility);
    return dynamicGraph || showGraph;
};


export default isGraphVisible;

























